import React from "react";

import { ButtonStandard, ModalBase, Text } from "@performyard/py-components";

type DiscardChangesModalProps = {
	isOpen: boolean;
	pendingCount: number;
	onConfirm: () => void;
	onClose: () => void;
};

// Dirty-exit confirm for a bulk level-edit session (PY-14092) — Cancel and the "Editing …" toggle
// both land here so there is one designed prompt instead of the old window.confirm. The route-leave
// guard (useUnsavedChanges) still uses the browser confirm; only in-page exits come through this.
const DiscardChangesModal = ({
	isOpen,
	pendingCount,
	onConfirm,
	onClose,
}: DiscardChangesModalProps): React.ReactElement => (
	<ModalBase isOpen={isOpen} onClose={onClose}>
		<div className="box-border w-[432px] px-6 pb-6">
			<Text size="sub-heading" weight="semi-bold" dangerouslySetClassName="text-center">
				Discard unsaved changes?
			</Text>
			<Text size="paragraph-1" dangerouslySetClassName="mt-4 text-center">
				{`You have ${pendingCount} unsaved level change${pendingCount === 1 ? "" : "s"}. Exiting will discard ${
					pendingCount === 1 ? "it" : "them"
				}.`}
			</Text>
			<div className="mt-6 flex justify-center gap-2">
				<div>
					<ButtonStandard size="large" variant="outline" color="neutral" onClick={onClose}>
						Keep Editing
					</ButtonStandard>
				</div>
				<div>
					<ButtonStandard
						size="large"
						color="primary"
						onClick={onConfirm}
						data-testid="discard-changes-confirm"
					>
						Discard Changes
					</ButtonStandard>
				</div>
			</div>
		</div>
	</ModalBase>
);

export default DiscardChangesModal;
